import React, { useState, useRef, useEffect } from "react";
import {
  BiChevronLeft,
  BiChevronLeftCircle,
  BiChevronRight,
  BiChevronRightCircle,
} from "react-icons/bi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { HiOutlineCalendarDays, HiSquares2X2 } from "react-icons/hi2";
import * as Tooltip from "@radix-ui/react-tooltip";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomToolbarOrdering = (toolbar) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  const goToBack = () => toolbar.onNavigate("PREV");
  const goToNext = () => toolbar.onNavigate("NEXT");
  const goToToday = () => toolbar.onNavigate("TODAY");
  const changeView = (view) => toolbar.onView(view);

  const handleDateChange = (date) => {
    setIsCalendarOpen(false);
    toolbar.onNavigate("DATE", date);
  };

  // 🔹 Close on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setIsCalendarOpen(false);
      }
    }

    if (isCalendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("touchstart", handleClickOutside); // ✅ mobile
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [isCalendarOpen]);
  return (
    <div className="flex flex-col gap-6 my-6 text-text px-4">
      <h1 className="text-xl font-semibold text-redlight">Orders Calendar</h1>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        {/* Date navigation */}
        <div className="flex items-center gap-2 flex-wrap justify-center sm:justify-start">
          <button onClick={goToBack} className="">
            <BiChevronLeftCircle />
          </button>

          {/* Current date display */}
          <span className="font-semibold text-redlight">
            {moment(toolbar.date).format("ddd D MMM")}
          </span>

          <button onClick={goToNext} className="">
            <BiChevronRightCircle />
          </button>

          <div className="relative flex items-center">
            <button
              onClick={goToToday}
              className="ml-2 px-3 py-1 border border-redlight rounded text-sm text-redlight h-[30px]"
            >
              Today
            </button>

            {/* Calendar icon next to Today */}
            <button
              onClick={() => setIsCalendarOpen((prev) => !prev)}
              className="ml-2 px-2 py-1 h-[30px] border border-redlight rounded text-sm text-redlight flex items-center justify-center"
            >
              <FaRegCalendarAlt className="text-base" />
            </button>

            {/* Calendar popup */}
            {isCalendarOpen && (
              <div
                ref={calendarRef}
                className="
      fixed inset-0 flex items-center justify-center z-50   /* full overlay on mobile */
      sm:absolute sm:inset-auto sm:top-12 sm:right-0 sm:z-50 sm:block lg:left-20
    "
              >
                <div className="bg-white shadow-lg border rounded">
                  <DatePicker
                    selected={toolbar.date}
                    onChange={handleDateChange}
                    inline
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* View buttons */}
        <Tooltip.Provider delayDuration={100}>
          <div className="flex gap-2 justify-center sm:justify-end flex-wrap">
            {[
              { icon: <FaRegCalendarAlt />, label: "1 Day", view: "day" },
              { icon: <HiOutlineCalendarDays />, label: "Week", view: "week" },
              { icon: <HiSquares2X2 />, label: "Month", view: "month" },
            ].map(({ icon, label, view }) => (
              <Tooltip.Root key={view}>
                <Tooltip.Trigger asChild>
                  <button
                    onClick={() => changeView(view)}
                    aria-label={label}
                    className="p-2 border border-redlight rounded text-redlight hover:bg-redlight hover:text-white transition-colors"
                  >
                    {icon}
                  </button>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    side="top"
                    align="center"
                    sideOffset={6}
                    className="bg-black text-white text-xs px-2 py-1 rounded-md shadow-lg z-50"
                  >
                    {label}
                    <Tooltip.Arrow className="fill-black" />
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            ))}
          </div>
        </Tooltip.Provider>
      </div>
    </div>
  );
};

export default CustomToolbarOrdering;
